<template>
  <div class="nav-bar clearfix">
    <Login />
    <Search />
  </div>
</template>
<script>
import Search from '@/components/Navbar/Search.vue';
import Login from '@/components/Navbar/Login.vue';

export default {
  components: { Search, Login },
};
</script>

<style lang="scss" scoped>
.nav-bar {
  margin: -38px auto 0 auto;
  position: relative;
  Logined {
    float: left;
  }
  Search{
    float: right;
  }
}
</style>
